import { render, staticRenderFns } from "./VacancyCompareChart.vue?vue&type=template&id=5f6d2b3a&"
import script from "./VacancyCompareChart.vue?vue&type=script&lang=js&"
export * from "./VacancyCompareChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports